import { useLanguage } from "../LanguageContext";

export default function TermsOfServiceView() {
  const { isAr } = useLanguage();
  const t = (en, ar) => (isAr ? ar : en);

  return (
    <div className="view-enter pt-24 sm:pt-28 md:pt-32 pb-12 sm:pb-16 md:pb-20 px-4 sm:px-6 bg-secondary-50 min-h-screen">
      <div className="max-w-3xl mx-auto">
        <div className="mb-10 sm:mb-12">
          <h3 className="text-primary-700 font-bold tracking-widest uppercase mb-2 text-sm font-display">
            {t("Legal", "قانوني")}
          </h3>
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4 font-display">
            {t("Terms of Service", "شروط الخدمة")}
          </h1>
          <div className="h-1 w-12 sm:w-16 rounded-full bg-axion-gold" />
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-8 md:p-10 space-y-6 sm:space-y-8 text-gray-700 leading-relaxed">
          <div>
            <h2 className="text-xl font-black text-gray-900 mb-3 font-display">
              {t("Using our website", "استخدام موقعنا الإلكتروني")}
            </h2>
            <p className="text-gray-600">
              {t(
                "By using this website, you agree to act in accordance with applicable laws in the Kingdom of Saudi Arabia.",
                "باستخدام هذا الموقع، توافق على التصرف وفقاً للقوانين المعمول بها في المملكة العربية السعودية."
              )}
            </p>
          </div>

          <div className="border-t border-gray-100 pt-6">
            <p className="text-gray-600">
              {t(
                "Content is provided for informational purposes and may be updated without prior notice.",
                "المحتوى مقدم لأغراض إعلامية وقد يتم تحديثه دون إشعار مسبق."
              )}
            </p>
          </div>

          <div className="border-t border-gray-100 pt-6">
            <p className="text-gray-600">
              {t(
                "Unauthorized use, reproduction, or distribution of content is prohibited.",
                "الاستخدام أو الاستنساخ أو التوزيع غير المصرح به للمحتوى محظور."
              )}
            </p>
          </div>

          <div className="border-t border-gray-100 pt-6">
            <p className="text-gray-600">
              {t(
                "For service agreements and project work, contractual terms agreed with Axion prevail.",
                "بالنسبة لاتفاقيات الخدمة وأعمال المشاريع، تسود الشروط التعاقدية المتفق عليها مع أكسيون."
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
